import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/public/Login'
import Forgot from '../views/public/Forgot'
import ResetPassword from '../views/public/ResetPassword'
import ActiveTaskTable from '../views/private/management/jobTasks/ActiveTasks'
import ArchivedTaskTable from '../views/private/management/jobTasks/ArchivedTasks'
import CompletedTaskTable from '../views/private/management/jobTasks/CompletedTasks'
import DelayedTaskTable from '../views/private/management/jobTasks/DelayedTasks'
import InProgressTaskTable from '../views/private/management/jobTasks/InProgressTasks'
import ActiveStaff from '../views/private/management/users/Staff'
import ArchivedStaff from '../views/private/management/users/Archived'
import ArchivedRoutes from '../views/private/management/routes/ArchivedRoutes'
import ActiveRoutes from '../views/private/management/routes/ActiveRoutes'
import WorkerRoutes from '../views/private/worker/WorkerRoutes'
import WorkerProfile from '../views/private/worker/WorkerProfile'
import WorkerMap from '../views/private/worker/WorkerMap'
import Map from '../views/private/Map'
import PreviewFile from '../views/private/ImportPreview'
import RoutePlanning from '../views/private/RoutePlanning'
import store from '../store';

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login,
            beforeEnter: redirect
        },
        {
            path: '/forgot',
            name: 'Forgot',
            component: Forgot,
        },
        {
            path: '/account/resetpassword/(.*)',
            name: 'ResetPassword',
            component: ResetPassword
        },
        {
            path: '/management/staff',
            name: 'Staff',
            component: ActiveStaff,
            beforeEnter: authorized
        },
        {
            path: '/management/staff/archived',
            name: 'Archived',
            component: ArchivedStaff,
            beforeEnter: authorized
        },
        {
            path: '/management/tasks/active',
            name: 'ActiveTasks',
            component: ActiveTaskTable,
            beforeEnter: authorized
        },
        {
            path: '/management/tasks/archived',
            name: 'ArchivedTasks',
            component: ArchivedTaskTable,
            beforeEnter: authorized
        },
        {
            path: '/management/tasks/completed',
            name: 'CompletedTasks',
            component: CompletedTaskTable,
            beforeEnter: authorized
        },
        {
            path: '/management/tasks/delayed',
            name: 'DelayedTasks',
            component: DelayedTaskTable,
            beforeEnter: authorized
        },
        {
            path: '/management/tasks/inprogress',
            name: 'InProgressTasks',
            component: InProgressTaskTable,
            beforeEnter: authorized
        },
        {
            path: '/management/routes/active',
            name: 'ActiveRoutes',
            component: ActiveRoutes,
            beforeEnter: authorized
        },
        {
            path: '/management/routes/archived',
            name: 'ArchivedRoutes',
            component: ArchivedRoutes,
            beforeEnter: authorized
        },
        {
            path: '/user/routes',
            name: 'WorkerRoutes',
            component: WorkerRoutes,
            beforeEnter: authorized
        },
        {
            path: '/user/map',
            name: 'WorkerMap',
            component: WorkerMap,
            beforeEnter: authorized
        },
        {
            path: '/user/profile',
            name: 'WorkerProfile',
            component: WorkerProfile,
            beforeEnter: authorized
        },
        {
            path: '/map',
            name: "Map",
            component: Map,
            beforeEnter: authorized
        },
        {
            path: '/file/preview',
            name: 'PreviewFile',
            component: PreviewFile,
            beforeEnter: authorized
        },
        {
            path: '/planning',
            name: 'RoutePlanning',
            component: RoutePlanning,
            beforeEnter: authorized
        }
    ]
})
function redirect (from, to, next) {
    if (store.state.auth.isLoggedIn === true) {
        if(store.state.user.currentUser != null && store.state.user.currentUser.roles[0]){
            if (store.state.user.currentUser.roles[0].toLowerCase() === 'admin') {
                next({path: '/map'})
            } else {
                next({path: '/user/routes'})
            }
        } else {
            next()
        }
    } else {
        next()
    }
}
function authorized (from, to, next) {
    if (store.state.auth.isLoggedIn === true) {
        next()
    } else {
        next({ path: '/' })
    }
}

